import { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../items/style/animationstyle';
import './machine_css.css';
import MachineProductsCard from './machineProductsCard';
import { ReactComponent as BackIcon } from '../Icons/Back_icon.svg';
import { ReactComponent as CartIcon } from '../Icons/Cart_icon.svg';
import { ReactComponent as HomeIcon } from '../Icons/Home_icon.svg';
import { ReactComponent as GiftIcon } from '../Icons/gift.svg';
import { ReactComponent as SearchIcon } from '../Icons/magnifier.svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import 'react-simple-keyboard/build/css/index.css';
import { useHistory } from 'react-router';
import Search from './items/Search';
import PlanModal from './PlanModal';
import logger from '../services/LocalServer/logger';
import Cookies from 'js-cookie';
import { ExitToApp } from '@material-ui/icons';
import ToggleLanguage from '../items/buttons/ToggleLanguage';
import BottomCart from './ShoppingCart/BottomCart';

function MachineProducts(props) {
  const homepage = localStorage.getItem('homepage');
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const {
    langs,
    MAXCARTNUM,
    itemCounter,
    brandOrCate,
    stat,
    setStat,
    add,
    catename,
    setlangs,
    decreStock,
    alterquantity,
    remove,
    setShowCart,
    showCart,
    cart,
  } = props;
  const { t } = useTranslation();
  const machineID = props.machineID;
  let logoutIcon = localStorage.getItem('LOGOUT') === 'TRUE';
  const [input, setInput] = useState('');
  const [column, setColumn] = useState('3');
  const [show, setShow] = useState(false);
  const [showp, setShowp] = useState(false);
  const [myprod, setmyprod] = useState(null);
  const [mainL, setMainL] = useState('en-US');
  const [languages, setLanguage] = useState([]);

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
    setLanguage(
      JSON.parse(localStorage.getItem('machine'))
        ? JSON.parse(localStorage.getItem('machine')).languages
        : null
    );
  }, []);

  const currentCate = JSON.parse(localStorage.getItem('currentCate'))
    ? JSON.parse(localStorage.getItem('currentCate'))
    : null;

  let Fname = '';
  if (currentCate?.name) {
    Fname =
      currentCate.name[langs] && currentCate.name[langs] !== ''
        ? currentCate.name[langs]
        : currentCate.name?.en;
  }

  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  symbol = symbol ? symbol : '$';

  const fColumn = () => {
    let c = JSON.parse(localStorage.getItem('machine'));
    let result = '3';
    if (c.themeColor && c.themeColor.p_column) {
      result = c.themeColor.p_column;
    }
    return result;
  };

  let history = useHistory();

  useEffect(() => {
    setColumn(fColumn());
    window.scrollTo(0, 0);
    logger(2, `Machine on products page with products of ${props?.catename}.`);
  }, []);

  useEffect(() => {
    if (brandOrCate === 'all') {
      stat.all_prod = stat.all_prod += 1;
    } else {
      if (brandOrCate === 'cate') {
        const index = stat?.cate.findIndex((item) => item._id === catename);
        if (index >= 0) {
          stat.cate[index].detail = stat.cate[index].detail += 1;
        } else {
          stat.cate.push({
            _id: catename,
            detail: 1,
            name: currentCate.name?.en,
          });
        }
      }
      if (brandOrCate === 'brand') {
        const index = stat?.brand.findIndex((item) => item._id === catename);
        if (index >= 0) {
          stat.brand[index].detail = stat.brand[index].detail += 1;
        } else {
          stat.brand.push({
            _id: catename,
            detail: 1,
            name: currentCate.name?.en,
          });
        }
      }
    }

    // console.log(stat);
    setStat(stat);
  }, []);

  let result = JSON.parse(localStorage.getItem('products'));
  if (input.length > 0) {
    result = result.filter((product) =>
      product.name[langs]?.toLowerCase().includes(input.toLowerCase())
    );
  }
  if (props.brandOrCate == 'brand') {
    result = result.filter((product) => product.brand?._id == props.catename);
  } else if (props.brandOrCate == 'cate') {
    result = result.filter((product) => product.category.includes(props.catename));
  }

  //sort by name
  result = result?.sort((a, b) => {
    const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
    const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  //filter out of stock
  const current = [];
  const soldOut = [];

  result.forEach((item) => {
    if (item.current_stock > 0) {
      current.push(item);
    } else {
      soldOut.push(item);
    }
  });

  result = current.concat(soldOut);

  const products = result.map((prod) => {
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.productPictures[0]}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    const plus = prod.current_stock > 0 && itemCounter < MAXCARTNUM ? true : false;

    return (
      <MachineProductsCard
        plus={plus}
        langs={props.langs}
        mainL={mainL}
        symbol={symbol}
        column={column}
        setShowp={setShowp}
        setmyprod={setmyprod}
        cart={props.cart}
        alterquantity={props.alterquantity}
        add={props.add}
        key={prod._id}
        decreStock={props.decreStock}
        machineID={machineID}
        price={prod.price}
        id={prod._id}
        prod={prod}
        products={props.products}
        i={prod.idx}
        name={prod.name}
        buyX={prod.buyX}
        percentage={prod.percentage}
        discountedPrice={prod.discountedPrice}
        amount={prod.nextPurchase ? prod.dis : prod.discount}
        nextPurchase={prod.nextPurchase}
        image={url}
      />
    );
  });

  return (
    <div className="ui-secondary-div">
      <motion.div
        key="product-div"
        className="container"
        initial="initial"
        exit="out"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}
      >
        <img className="category-logo" alt="Logo" />
        <div className="row align-items-center justify-content-center">
          <div>
            {languages != null && (
              <ToggleLanguage
                setlangs={setlangs}
                langs={langs}
                p="p"
                l={languages}
                machineID={machineID}
              />
            )}
          </div>
          <div style={{ marginLeft: '50px' }}>
            <Search show={show} setShow={setShow} input={input} setInput={setInput} />
          </div>
        </div>
        <div className="row justify-content-center mt-5 mb-5">
          <span className="cat-title">
            {result.length == 0 ? (
              <h2>{t(`No matching products is found`)}!</h2>
            ) : props.brandOrCate === 'all' ? (
              t(``)
            ) : (
              Fname
            )}
          </span>
        </div>
        <div
          id={column === '3' ? 'productListRow' : 'productListRow1'}
          style={{
            justifyContent: 'space-evenly',
            flexWrap: 'wrap',
          }}
          className="row items-container"
        >
          {products}
        </div>
      </motion.div>
      <GiftIcon className="svg-style giftsvg-p" />
      <div className="bottom-buttons-div">
        <Link to={homepage}>
          <HomeIcon className="svg-style mr-3" />
        </Link>

        <CartIcon
          className="svg-style myCartIcon"
          onClick={() => {
            if (localStorage.getItem('cartStyle') === 'true') {
              setShowCart(true);
            } else {
              console.log('222222222');
              history.push(`/machineUI/${props.machineID}/checkout`);
            }
          }}
        />
        <span className="item-counter-p">
          <span className="myCartCounter">{props.itemCounter}</span>
        </span>

        <BackIcon
          id="mybackIcon"
          className="svg-style ml-3 backIcon"
          onClick={() => {
            history.push(homepage);
          }}
        />
        <span
          onClick={() => {
            setShow(true);
            setInput('');
          }}
        >
          <SearchIcon className="svg-style mr-3" />
        </span>
        {logoutIcon && (
          <Link to={`/machineUI/slider/${machineID}`}>
            <ExitToApp className="svg-style myCartIcon" />
          </Link>
        )}
      </div>
      <PlanModal
        cart={props.cart}
        alterquantity={props.alterquantity}
        add={props.add}
        prod={myprod}
        show={showp}
        onHide={() => {
          setShowp(false);
        }}
      />
      <BottomCart
        isLocal={isLocal}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
      />
    </div>
  );
}
export default MachineProducts;
